<script setup>
import { computed } from 'vue'
import { PROVIDER_ROUTE, PROVIDER_BANNER_DEFAULT } from './captionSyncWords'

/**
 * Slim line on the captioning pages saying whose SyncWords account new
 * captioning runs on, with a link to Settings -> Developers. One of the few
 * places the vendor is named (`data-vendor-name`).
 */
const props = defineProps({
	// `provider` from `GET /captions/engine`: { connected, account: { id, name } | null }.
	provider: { type: Object, default: null },
})

const connected = computed(() => !!props.provider?.connected && !!props.provider?.account)
// "Using Syncwords? · Connect your own account": the link is the part after the dot.
const [lead, action] = PROVIDER_BANNER_DEFAULT.split(' · ')
</script>

<template>
	<p
		class="m-0 flex flex-wrap items-center gap-x-1.5 gap-y-1 rounded-lg bg-surface-2 px-3 py-2 text-xs text-surface-8"
		:data-connected="connected ? 'true' : 'false'"
		data-vendor-name
		data-testid="caption-provider-banner"
	>
		<span class="size-1.5 shrink-0 rounded-full" :class="connected ? 'bg-success' : 'bg-surface-6'" aria-hidden="true" />
		<span v-if="connected">Using your SyncWords account · <span class="font-medium text-surface-text-1" data-testid="caption-provider-banner-account">{{ provider.account.name }}</span> · <router-link :to="PROVIDER_ROUTE" class="font-medium text-main-light hover:underline">Manage</router-link></span>
		<span v-else>{{ lead }} · <router-link :to="PROVIDER_ROUTE" class="font-medium text-main-light hover:underline">{{ action }}</router-link></span>
	</p>
</template>
